<div class="ordonnance-etat-container">
    <form *ngIf="ordonnanceMessageForm" [formGroup]="ordonnanceMessageForm" (ngSubmit)="onSubmit()">
        <div class="row process-row process-message">
            <div class="col-md-12">
                <label>Message à transmettre vers l'application du smartphone :</label>
                <textarea rows="5" formControlName="message"></textarea>
            </div>
            <div *ngIf="submitted && field.message.errors" class="invalid-feedback">
                <div *ngIf="field.message.errors.required">Le message est requis</div>
            </div>
        </div>
        <div class="row process-row process-bal">
            <div class="col-md-12"><input formControlName="copyMail" type="checkbox" id="check-bal" /><label for="check-bal">Envoyer une copie dans ma BAL</label></div>
        </div>
    </form>
</div>